export type NavigationAppState = Readonly<{
    sideNavCollapsed: boolean
}>

export const selectSideNavCollapsed = (s: NavigationAppState): boolean => s.sideNavCollapsed
